// Copyright ©️ 2026 eVolve MEP, LLC

import type { RackDimensionLabelId } from 'components/Autodesk/extensions/DimensioningExtension/RackDimensions/rendering/buildRackDimensionPlan';
import { getBasicStoreListeners } from 'helpers/getBasicStoreListeners';

/** A dimension label projected into the viewer container's pixel space, ready for React to render. */
export type RenderedRackLabel = {
  rackDimensionLabelId: RackDimensionLabelId;
  /** The formatted measurement, e.g. `6-1/2"`. */
  text: string;
  /** Pixel X within `viewer.container` (center of the label). */
  x: number;
  /** Pixel Y within `viewer.container` (center of the label). */
  y: number;
  visible: boolean;
};

/** Bridges `RackDimensionRenderingManager`'s projected label positions to the React layer. */
export const createRenderedRackLabelsStore = () => {
  let labels: readonly RenderedRackLabel[] = [];
  const { subscribe, notifyListeners } = getBasicStoreListeners();

  return {
    getSnapshot: (): readonly RenderedRackLabel[] => labels,
    subscribe,
    /** Called by `RackDimensionRenderingManager` whenever the plan or the camera changes. */
    setLabels: (next: RenderedRackLabel[]) => {
      labels = next;
      notifyListeners();
    },
    clear: () => {
      labels = [];
      notifyListeners();
    },
  } as const;
};

export type RenderedRackLabelsStore = ReturnType<typeof createRenderedRackLabelsStore>;
